const PAGE_ALERT = {
  SUCCESS: "success",
  INFO: "info",
  WARNING: "warning",
  DANGER: "danger",
};

export default PAGE_ALERT;
